@use "../../../styles/breakpoint.module.scss" as *;

.twoUpContainer {
    grid-column: content;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--spacer-40);

    @media ($below-mobile) {
        grid-template-columns: 1fr;
    }
}

.twoUpCard {
    position: relative;
    overflow: hidden;

    &.imageFill {
        display: flex;
        min-height: 640px;

        @media ($below-mobile) {
            min-height: 480px;
        }

        .imageWrapper {
            position: absolute;
            inset: 0;
            z-index: 0;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .contentWrapper {
            position: relative;
            width: 100%;
            z-index: 1;
            display: flex;
            flex-direction: column;
            padding: var(--spacer-32);
            gap: var(--spacer-16);
            color: var(--white);
            margin-top: auto;
            background: linear-gradient(
                0deg,
                rgb(0 0 0 / 90%) 0%,
                rgb(0 0 0 / 0%) 100%
            );
        }
    }

    &.imageBlock {
        display: flex;
        flex-direction: column;

        .imageWrapper {
            aspect-ratio: 3 / 2;
            max-height: 480px;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .contentWrapper {
            display: flex;
            width: 100%;
            flex-direction: column;
            justify-content: flex-end;
            padding: var(--spacer-32);
            color: var(--color-text);
            gap: var(--spacer-16);
            margin-top: auto;
            flex: 1;
        }
    }
}

.headline {
    composes: fontHB80 from "../../../styles/typography.module.scss";

    .imageBlock & {
        color: var(--color-text);
    }
}

.body {
    composes: fontP20 from "../../../styles/typography.module.scss";
    margin-bottom: var(--spacer-8);

    .imageBlock & {
        color: var(--color-text);
    }
}

.ctaWrapper {
    margin-top: auto;

    .twoUpContainer:has(.imageFill):has(.imageBlock) & {
        margin-top: 0;
    }
}
